import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Minus: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--minus')}
    data-icon={icon}
    width="12"
    height="2"
    viewBox="0 0 12 2"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Accordion-Open" fill="#17171D">
        <rect
          id="Minus"
          transform="translate(6.058422, 1.103011) rotate(-270.000000) translate(-6.058422, -1.103011) "
          x="5.30842204"
          y="-4"
          width="1.5"
          height="10.2060222"
        />
      </g>
    </g>
  </svg>
);

export default Minus;
